// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { resolveColor } from "@insite/mobius/utilities";
import { css } from "styled-components";

/**
 * Add custom style for scrollbar
 * @param width
 */
export const styledScrollbar = (width = 2) => {
    return ({ theme }: any) => css`
        scrollbar-width: thin;
        scrollbar-color: ${resolveColor("common.ui6", theme)} ${resolveColor("common.ui13", theme)};
        overflow-y: auto;

        &::-webkit-scrollbar {
            width: ${width}px;
            height: ${width}px;
        }
        &::-webkit-scrollbar-track {
            background: ${resolveColor("common.ui13", theme)};
        }
        &::-webkit-scrollbar-thumb {
            background-color: ${resolveColor("common.ui6", theme)};
            border-radius: 6px;
            border: 3px solid transparent;
        }
        &::-webkit-scrollbar-thumb:hover {
            background: ${resolveColor("common.ui6", theme)};
        }
    `;
};

export const hideScrollBar = css`
    &::-webkit-scrollbar {
        display: none;
    }
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */

    /* this prevent scroll outside the container */
    overscroll-behavior-y: contain;
`;

export const addScrollbarGutter = () => {
    if (typeof document === "undefined") {
        return;
    }
    document.querySelector("html")?.setAttribute("style", "scrollbar-gutter: stable;");
};

export const removeScrollbarGutter = () => {
    if (typeof document === "undefined") {
        return;
    }
    document.querySelector("html")?.removeAttribute("style");
};

/**
 * Scroll to invalid field
 * @param scrollToTop
 */
export const doScroll = (scrollToTop = false) => {
    setTimeout(
        () => {
            const selector = document.querySelector("[aria-invalid='true']");

            if (selector) {
                selector.scrollIntoView({
                    behavior: "smooth",
                    block: "center",
                });

                return;
            }

            if (scrollToTop) {
                window.scrollTo({
                    top: 0,
                    left: 0,
                    behavior: "smooth",
                });
                return;
            }

            doScroll(scrollToTop);
        },
        scrollToTop ? 10 : 500,
    );
};
